/* NL Contact — client-side validation, then native Shopify contact-form submit */
(function(){
  function init(root){
    if(root.__nlCt) return; root.__nlCt = true;
    var form = root.querySelector('form.ct-form'); if(!form) return;
    var done = root.querySelector('[data-ct-done]'), alertBox = root.querySelector('[data-ct-alert]');
    var target = done || alertBox;
    if(target){ setTimeout(function(){ try{ target.scrollIntoView({behavior:'smooth', block:'center'}); target.focus({preventScroll:true}); }catch(e){} }, 150); }

    var rules = {
      name:  { el:'[name="contact[name]"]',  test:function(v){ return v.trim().length > 1; }, msg:'Please enter your name.' },
      email: { el:'[name="contact[email]"]', test:function(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); }, msg:'Please enter a valid email address.' },
      phone: { el:'[name="contact[phone]"]', test:function(v){ return !v.trim() || /^[+()\d][\d\s().-]{6,19}$/.test(v.trim()); }, msg:'Please enter a valid phone number.' },
      body:  { el:'[name="contact[body]"]',  test:function(v){ return v.trim().length > 4; }, msg:'Please tell us how we can help.' }
    };
    function check(k){
      var r = rules[k], el = form.querySelector(r.el), msg = form.querySelector('[data-err="'+k+'"]');
      if(!el) return true;
      var ok = r.test(el.value);
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if(msg){ msg.textContent = ok ? '' : r.msg; }
      return ok;
    }
    Object.keys(rules).forEach(function(k){
      var el = form.querySelector(rules[k].el); if(!el) return;
      el.addEventListener('blur', function(){ check(k); });
      el.addEventListener('input', function(){ if(el.getAttribute('aria-invalid') === 'true') check(k); });
    });
    form.addEventListener('submit', function(e){
      var firstBad = null;
      Object.keys(rules).forEach(function(k){
        if(!check(k) && !firstBad) firstBad = form.querySelector(rules[k].el);
      });
      if(firstBad){ e.preventDefault(); firstBad.focus(); return; }
      var hp = form.querySelector('[name="company"]'); if(hp && hp.value){ e.preventDefault(); return; }
      var b = form.querySelector('[data-ct-submit]'); if(b){ b.disabled = true; b.textContent = 'Sending…'; }
    });
  }
  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-nl-contact]'), init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();